import { render, staticRenderFns } from "./FormIframe.vue?vue&type=template&id=b1669d8e&scoped=true"
import script from "./FormIframe.vue?vue&type=script&lang=js"
export * from "./FormIframe.vue?vue&type=script&lang=js"
import style0 from "./FormIframe.vue?vue&type=style&index=0&id=b1669d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1669d8e",
  null
  
)

export default component.exports